import React, { useEffect, Suspense } from "react";
import { Route, Link, Redirect, Switch } from "react-router-dom";
import menuData from "./routes";
import BasicLayoutWrapper from "./layouts/BasicLayout";
import Login from "./containers/login/views";

import { useDispatch, useSelector } from "react-redux";
import Exception from "./components/Exception";
import DocumentTitle from "react-document-title-sz";
import moment from "moment-timezone";

import { isDev } from "./settings";
import TwoFactorAuthentication from "./containers/login/views/TwoFactorAuthentication";

moment.tz.setDefault("Africa/Bamako"); //to match user's default timezone with GMT

const Exp = () => (
  <Exception
    type="404"
    desc={"You seem lost!"}
    linkElement={Link}
    redirect={"/publicInstrument"}
    backText={"Go To Homepage?"}
  />
);

const routesExcludeWIthPermissions = ["addInvestment", "addLoan", "addCash"];

export default function App() {
  const dispatch = useDispatch();
  const { token, currentUser } = useSelector((state) => ({
    currentUser: state.global.currentUser,
    token: state.global.token,
  }));

  const path = window.location.pathname;
  const guestLoginPath = "/login/guest";

  useEffect(() => {
    const onLoad = (e) => {
      let sessionId = sessionStorage.getItem("tokenAdmin");
      let remId = localStorage.getItem("rememberMeAdmin");

      if (!sessionId && remId != "true") {
        localStorage.clear();
        dispatch({ type: "SET_LOGIN_RESPONSE", payload: null });
        dispatch({ type: "NATIVE_REGISTER", payload: null });
        dispatch({
          type: "SET_DASHBOARD_GRAPH_DATA",
          payload: { dataArr: [], labelArr: [] },
        });
        dispatch({ type: "SET_ASSET_LIST", payload: [] });
        dispatch({ type: "ADD_SUBSCRIBER_RESP", payload: {} });
        dispatch({ type: "RESET_GUEST_DATA" });

        dispatch({ type: "LOGOUT" });
      }
    };
    window.addEventListener("load", onLoad);

    return () => {
      window.removeEventListener("load", onLoad);
    };
  }, [dispatch]);

  useEffect(() => {
    if (
      currentUser &&
      token &&
      !isNaN(parseInt(currentUser.id)) &&
      path !== guestLoginPath
    ) {
    }
  }, [currentUser, dispatch, path, token]);

  // console.log("Node envVV isss !!!!!!", process.env.NODE_ENV)

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Switch>
        {menuData.map((item, key) => {
          const permissionIsNotGranted = routesExcludeWIthPermissions.includes(
            item.key
          );
          if (permissionIsNotGranted || !item.component) {
            return null;
          }
          return (
            <Route
              exact
              path={item.path}
              key={item.path}
              render={(route) => {
                return (
                  <BasicLayoutWrapper component={item.component} item={item} />
                );
              }}
            />
          );
        })}

        <Route
          exact
          path={["/login", "/login/confirm"]}
          render={(route) => {
            if (currentUser && token) {
              return <Redirect to="/publicInstrument" />;
            }
            return (
              <DocumentTitle title={"Exirio | Login"}>
                <Login />
              </DocumentTitle>
            );
          }}
        />
        <Route
          exact
          path="/two_factor_authentication"
          render={(route) => {
            if (currentUser && token) {
              return <Redirect to="/publicInstrument" />;
            }
            return (
              <DocumentTitle title={"Two-factor authentication"}>
                <TwoFactorAuthentication />
              </DocumentTitle>
            );
          }}
        />

        <Route
          exact
          path="/signup"
          render={(route) => {
            if (currentUser && token) {
              return <Redirect to="/publicInstrument" />;
            }
            return (
              <DocumentTitle title={"Exirio | Register"}>
                <Login signup={true} />
              </DocumentTitle>
            );
          }}
        />

        <Route
          exact
          path="/"
          render={(route) => {
            if (!currentUser && !token) {
              return <Redirect to="/login" />;
            }
            return <Redirect to="/publicInstrument" />;
          }}
        />
        <Route component={Exp} />
      </Switch>
    </Suspense>
  );
}
